<template>
  <b-card
    class="mb-75"
    no-body
    :class="{ 'cursor-pointer': !isSelectedItem(item.idNotificacion) }"
    :bg-variant="isSelectedItem(item.idNotificacion) ? 'light-secondary' : ''"
    @click="$emit('update:notification-selected', item)"
  >
    <!-- Notification list -->
    <b-card-body>
      <h6>
        {{ item.titulo }}
        <b-card-text class="item-company">
          <!-- Fecha de emisión -->
          <small
            v-b-tooltip.hover.bottom="'Fecha de emisión'"
            class="mr-50"
            :class="isSelectedItem(item.idNotificacion) ? '' : 'text-muted'"
          >
            {{ timestampToDate(item.fecha, 'LLLL') }}
          </small>
          <!-- Indicador de liga -->
          <feather-icon
            v-if="item.url"
            v-b-tooltip.hover.bottom="'Notificación con liga'"
            icon="LinkIcon"
            class="mr-50"
          />
          <!-- Prioridad -->
          <span
            v-b-tooltip.hover.bottom="'Prioridad'"
            class="bullet bullet-sm"
            :class="`bullet-${notificationPriority(item.prioridad)}`"
          />
        </b-card-text>
      </h6>
    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardText,
  VBTooltip,
} from 'bootstrap-vue'
import {
  timestampToDate,
  notificationPriority,
} from '@core/utils/filter'
import { isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    notificationSelected: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const isSelectedItem = id => !isEmptyObject(props.notificationSelected) && props.notificationSelected.idNotificacion === id

    return {
      timestampToDate,
      notificationPriority,
      isSelectedItem,
    }
  },
}
</script>
